// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Slider_Slider__VYOud","Back":"Slider_Back__KZv30","Title":"Slider_Title__veU_0","Content":"Slider_Content__xd85z"};